import React, { useContext, useMemo } from 'react';
// eslint-disable-next-line id-length
import _ from 'lodash';
import classNames from 'classnames/bind';

import { Typography } from '@one-thd/sui-atomic-components';

import { EstimateApiContext } from '../context/EstimateApiContext';
import { RentalEstimateContext } from '../context/RentalEstimateContext';

import {
  formatCurrency,
  getFeeBreakdown
} from '../utils/rate-helper';

import styles from '../containers/rental-estimate.module.scss';

const cx = classNames.bind(styles);

export const Fees = () => {
  const { damageProtection } = useContext(RentalEstimateContext);
  const { data } = useContext(EstimateApiContext);

  const feeBreakdown = useMemo(() => getFeeBreakdown({ data, damageProtection }), [data, damageProtection]);

  if (_.isEmpty(feeBreakdown?.fees)) { return null; }

  return (
    <>
      <div className="sui-justify-self-start sui-col-span-6 sui-mt-2">
        <Typography weight="bold" data-automation-id="fees_label">Fees</Typography>
      </div>

      {feeBreakdown?.fees.map((fee) => (
        <>
          <div className="sui-justify-self-start sui-col-span-5">
            <Typography data-automation-id="damageProtection_label">
              {fee.name}
            </Typography>
          </div>
          <div className="sui-inline-flex sui-justify-self-end">
            <Typography data-automation-id="damageProtection_value">
              {formatCurrency(fee.cost)}
            </Typography>
          </div>
        </>
      ))}
    </>
  );
};

Fees.displayName = 'Fees';
